import Image from "./../image";
import Text from "./../text/text";

interface AIAgentButtonProps {
  onClick: () => void;
}

const AIAgentButton: React.FC<AIAgentButtonProps> = ({ onClick }) => {
  return (
    <div
      id="ai-agent-button"
      className="btn-style bg-overlay px-[20px] py-[8px] rounded-[500px] cursor-pointer"
      onClick={() => onClick()}
    >
      <div className="flex gap-2 items-center">
        <Image
          src="/assets/icon_ai_agent.png"
          alt="agent button"
          width={22}
          height={22}
        />
        <Text text="ai_agent" className="text-500 truncate" size={15} />
      </div>
    </div>
  );
};

export default AIAgentButton;
